import { render, staticRenderFns } from "./DetailsBox.vue?vue&type=template&id=1da8cf3f&scoped=true&lang=html&"
import script from "./DetailsBox.vue?vue&type=script&lang=js&"
export * from "./DetailsBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da8cf3f",
  null
  
)

export default component.exports